// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c6ddc42b","239":"a97f1a2f","667":"a6e54715","885":"4a00a962"}[chunkId] + ".chunk.js";
};